import React, { Component, createRef, forwardRef, useImperativeHandle } from "react";
import { View, Image, TextInput, Text, FlatList, ActivityIndicator} from "react-native-web";
import { ParallaxProvider, ParallaxBanner, Parallax } from 'react-scroll-parallax';
import { AnimatePresence, motion, useScroll, useTransform, useMotionValue } from 'framer-motion';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import Item from '../home/Item';
import ZoomPreview from '../home/ZoomPreview';

import momentStore from '../../../store/momentStore';
import pageStore from '../../../store/pageStore';

import i18n from "../../../i18n";

import Footer from "../../footer/Footer";


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;



let titleFontSize30, titleFontSize25, titleFontSize22, titleFontSize20, titleFontSize19, titleFontSize18, titleFontSize17, titleFontSize16, titleFontSize15, titleFontSize13, titleFontSize;

if (viewportWidth > 1400)
{
   titleFontSize = 40;
   titleFontSize30 = 30;
   titleFontSize25 = 25;
   titleFontSize22 = 22;
   titleFontSize20 = 20;
   titleFontSize19 = 19;
   titleFontSize18 = 18;
   titleFontSize17 = 17;
   titleFontSize16 = 16;
   titleFontSize15 = 15;
   titleFontSize13 = 13;
}
else if (viewportWidth > 1200)
{
   titleFontSize = 35;
   titleFontSize30 = 26;
   titleFontSize25 = 22;
   titleFontSize22 = 20;
   titleFontSize20 = 19;
   titleFontSize19 = 18;
   titleFontSize18 = 17;
   titleFontSize17 = 16;
   titleFontSize16 = 15;
   titleFontSize15 = 14;
   titleFontSize13 = 12;
}
else
{
   titleFontSize = 30;
   titleFontSize30 = 24;
   titleFontSize25 = 19;
   titleFontSize22 = 17;
   titleFontSize20 = 18;
   titleFontSize19 = 17;
   titleFontSize18 = 16;
   titleFontSize17 = 15;
   titleFontSize16 = 14;
   titleFontSize15 = 13;
   titleFontSize13 = 11;
}


const NUM_VISIBLE_ITEMS = 4;
const ARROW_WIDTH = 60;
const ITEM_SPACING = 22;


class SearchPagePC extends Component {

    constructor(props) {

          super(props);

          this.gridRef = React.createRef();

         let numColumns;
         if (window.innerWidth > 1400)
         {
             numColumns = 4;
         }
         else if (window.innerWidth > 1200)
         {
             numColumns = 4;
         }
         else
         {
             numColumns = 3;
         }


         const itemWidth = Math.floor((viewportWidth-185) / numColumns);


     	   this.state = {

           itemWidth: itemWidth,
           numColumns: numColumns,
           hoveredItem: null,
           hoverPosition: null, // { x: 0, y: 0 },
           pendingItem: null,
           pendingPosition: null,
           viewportWidth: window.innerWidth,
           viewportHeight: window.innerHeight,
     	   };



     }




    componentDidMount(){

       window.addEventListener('resize', this.handleResize);
       this.handleResize(); // initialize on mount

	  }

	  UNSAFE_componentWillMount(){

	  }

	 UNSAFE_componentWillUnmount(){
      window.removeEventListener('resize', this.handleResize);
	  }




   handleResize = () => {


         let numColumns;
         if (window.innerWidth > 1400)
         {
             numColumns = 4;
         }
         else if (window.innerWidth > 1200)
         {
             numColumns = 4;
         }
         else
         {
             numColumns = 3;
         }


         const itemWidth = Math.floor((viewportWidth-185) / numColumns);


         this.setState({
           itemWidth: itemWidth,
           numColumns: numColumns,
           viewportWidth: window.innerWidth,
           viewportHeight: window.innerHeight,
         });


   }



   hoverTimeout = null;

   _handleItemHover = (item, rect) => {
   if (this.state.hoveredItem && item.id !== this.state.hoveredItem.id) {
     // Un autre est déjà affiché → stocke temporairement
     this.setState({
       pendingItem: item,
       pendingPosition: {
         x: rect.left,
         y: rect.top,
         width: rect.width,
       },
       hoveredItem: null, // ← déclenche l’exit
     });
   } else {
     // Aucun ou même item → afficher directement
     this.setState({
       hoveredItem: item,
       hoverPosition: {
         x: rect.left,
         y: rect.top,
         width: rect.width,
       },
     });
   }
 }

   handleItemHover = (item, rect) => {
    const containerRect = this.gridRef.current.getBoundingClientRect();
    const relativeRect = {
      x: rect.left - containerRect.left,
      y: rect.top - containerRect.top,
      width: rect.width,
    };

    if (this.state.hoveredItem && item.id !== this.state.hoveredItem.id) {
      this.setState({
        pendingItem: item,
        pendingPosition: relativeRect,
        hoveredItem: null,
      });
    } else {
      this.setState({
        hoveredItem: item,
        hoverPosition: relativeRect,
      });
    }
  };

  handleItemLeave = () => {
    this.hoverTimeout = setTimeout(() => {
      this.setState({ hoveredItem: null });
    }, 150);
  };

  handleZoomEnter = () => {
    clearTimeout(this.hoverTimeout);
  };

  handleZoomLeave = () => {
    this.setState({ hoveredItem: null });
  };

  handleZoomExitComplete = () => {
  if (this.state.pendingItem) {
    this.setState({
      hoveredItem: this.state.pendingItem,
      hoverPosition: this.state.pendingPosition,
      pendingItem: null,
      pendingPosition: null,
    });
  }
 }

 handleZoomClose = () => {
   this.setState({ hoveredItem: null, hoverPosition: null });
  };





  previewMomentsHoveredItem = (object) => {
    this.props.onPreviewMoments(object, this.state.user);
  }

  previeCreditsHoveredItem = (object) => {
    this.props.onPreviewCredits(object, this.state.user);
  }






  render() {

  const { itemWidth, numColumns } = this.state;


    return (

        <div style={{position: 'fixed', zIndex: 9, top: 0, left: 0, backgroundColor: '#f3f5f8', width: this.state.viewportWidth+'px', height: this.state.viewportHeight+'px'}}>


              {this.props.queryResults.length === 0 &&
                <div style={{position: 'relative', width: this.state.viewportWidth+'px', height: this.state.viewportHeight+'px',}}>

                    <div style={{position: 'relative', width: this.state.viewportWidth+'px', height: (this.state.viewportHeight-70)+'px', marginTop: '70px', overflow: 'auto'}}>

                            <div style={{width: this.state.viewportWidth+'px'}}>
                                <div style={{width: (this.state.viewportWidth*0.8)+'px', margin: 'auto'}}>
                                        <View style={{width: (this.state.viewportWidth*0.8)+'px', height: (this.state.viewportHeight*0.7)+'px',
                                                      alignItems: 'center', justifyContent: 'center'}}>

                                            <div>
                                              <div style={{width: '80px', margin: 'auto', alignSelf: 'center'}}>
                                                  <img src={'/img/search_icon_2.png'} style={{width: '80px', height: '80px'}}/>
                                               </div>

                                               <div style={{textAlign: 'center', fontSize: titleFontSize25+'px', marginTop: 20, opacity: 1, color: '#555'}}>
                                                    {i18n.t('No_results_found')}
                                               </div>
                                            </div>


                                        </View>



                                        <div style={{height: (this.state.viewportHeight*0.05)+'px'}}/>


                                        <Footer/>
                                </div>
                            </div>

                        </div>
                  </div>
              }


              {this.props.queryResults.length > 0 &&
                <div style={{position: 'relative', width: this.state.viewportWidth+'px', height: this.state.viewportHeight+'px',}}>

                    <div style={{position: 'relative', width: this.state.viewportWidth+'px', height: (this.state.viewportHeight-70)+'px', marginTop: '70px', overflow: 'auto'}}>

                          <div style={{width: (this.state.viewportWidth-120)+'px', margin: 'auto', marginTop: '20px'}}>
                              <div style={{color: '#111', fontSize: titleFontSize20+'px'}}>{i18n.t('Search_results')}: {this.props.queryResults.length}</div>
                          </div>



                          <div style={{width: this.state.viewportWidth+'px', marginTop: '30px'}} >



                                        <div style={{position: 'relative', width: this.state.viewportWidth+'px',}}>

                                                {this.state.hoveredItem && this.state.hoverPosition && (
                                                 <ZoomPreview
                                                   key={this.state.hoveredItem.objectID}
                                                   item={this.state.hoveredItem}
                                                   position={this.state.hoverPosition}
                                                   onZoomEnter={this.handleZoomEnter}
                                                   onZoomLeave={this.handleZoomLeave}
                                                   onExitComplete={this.handleZoomExitComplete}
                                                   previewMoments={this.previewMomentsHoveredItem}
                                                   previewCredits={this.previeCreditsHoveredItem}
                                                   onClose={this.handleZoomClose}
                                                 />
                                               )}

                                               <div ref={this.gridRef}
                                                style={{
                                                  padding: `0 ${ARROW_WIDTH}px`,
                                                  display: 'grid',
                                                  gridTemplateColumns: `repeat(${numColumns}, 1fr)`,
                                                }}>
                                                {this.props.queryResults.map((item, index) => (
                                                  <div key={index} style={{marginBottom: '30px'}}>
                                                      <Item
                                                          item={item}
                                                          width={itemWidth}
                                                          isLast={index === this.props.queryResults.length - 1}
                                                          onHover={this.handleItemHover}
                                                          onLeave={this.handleItemLeave}
                                                        />
                                                  </div>
                                                ))}
                                              </div>


                                         </div>


                                         <div style={{height: '200px'}}/>

                                         <Footer/>



                          </div>

                    </div>

                </div>
              }





       </div>

    )
  }
}





export default SearchPagePC;
